import * as React from "react"

const ArrowLeft = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="m7.4 11.4.3.3.7-.7-.3-.4-2.2-2.1h6.6v-1H6l2-2.1.4-.4-.7-.7-.3.3-2.9 2.9-.1.1L4 8l.4.4.1.1 2.9 2.9Z" />
  </svg>
)

export default ArrowLeft
